export const VITE_OTP_GATEWAY_URL = import.meta.env.VITE_OTP_GATEWAY_URL;
export const VITE_ZEM_GATEWAY_URL = import.meta.env.VITE_ZEM_GATEWAY_URL;
export const LOAN_PURPOSE_PERSONAL = "Personal";
export const LOAN_PURPOSE_BUSINESS = "Business";
export const LOAN_PURPOSE_NOVATED_LEASE = "Novated Lease";
export const LOAN_PURPOSE_NEW = "New";
export const LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING = "Debt Consolidation / Refinancing";
export const EMP_STAT_SELF_EMPLOYED = "Self-employed";
export const ABN_STATUS_NEW_ABN = "New Business ABN";
export const BOAT_ASSET_TYPE_COMMERCIAL = "Commercial Boat";

// Initialised loan types
export const ALL_LOAN_TYPES =
	"Car Loan,Boat Loan,Caravan Loan,Truck Loan,Equipment Loan,Personal Loan";
export const LOAN_TYPE_PERSONAL = "Personal Loan";
export const LOAN_TYPE_CAR = "Car Loan";
export const LOAN_TYPE_BOAT = "Boat Loan";
export const LOAN_TYPE_BIKE = "Bike Loan";
export const LOAN_TYPE_MOTORCYCLE = "Motorcycle Loan";
export const LOAN_TYPE_CARAVAN = "Caravan Loan";
export const LOAN_TYPE_TRUCK = "Truck Loan";
export const LOAN_TYPE_EQUIPMENT = "Equipment Loan";

// Assets used in partner pages
export const ASSET_TYPE_CAR = "Cars";
export const ASSET_TYPE_CARAVAN = "Caravans";
export const ASSET_TYPE_TRUCK = "Trucks";
export const ASSET_TYPE_EQUIPMENT = "Equipment";
export const ASSET_TYPE_BEAUTY = "Beauty Equipment";
export const ASSET_TYPE_BIKE = "Bikes";
export const ASSET_TYPE_BOAT = "Boats";
export const ASSET_TYPE_PERSONAL = "Personal";
export const LOANTYPES_WLOANPURPOSE = [ASSET_TYPE_CAR, ASSET_TYPE_BOAT];

// Email typos
export const emailTypos: Record<string, string> = {
	// GMAIL
	"gamil.com": "gmail.com",
	"gmal.com": "gmail.com",
	"gmaill.com": "gmail.com",
	"gmial.com": "gmail.com",
	"gmaii.com": "gmail.com",
	"gamil.com.au": "gmail.com.au",
	"gmail.con": "gmail.com",
	"gmail.con.au": "gmail.com.au",
	"gamail.com": "gmail.com",

	// OUTLOOK
	"outlook.con": "outlook.com",
	"outlok.com": "outlook.com",
	"outllok.com": "outlook.com",
	"outlook.con.au": "outlook.com.au",

	// YAHOO
	"yaho.com": "yahoo.com",
	"yaboo.com.au": "yahoo.com.au",
	"yahoo.con.au": "yahoo.com.au",
	"yaho.com.au": "yahoo.com.au",
	"yahoo.con": "yahoo.com",
	"yhoo.com": "yahoo.com",

	// HOTMAIL
	"htmail.com": "hotmail.com",
	"hotmail.con": "hotmail.com",
	"hotmial.com": "hotmail.com",
	"hotmail.con.au": "hotmail.com.au",

	// ICLOUD / BIGPOND
	"icloud.con": "icloud.com",
	"iclou.com": "icloud.com",
	"bigpond.con": "bigpond.com",
	"bigpond.com.au": "bigpond.com",
	"bigpond.con.au": "bigpond.com",
};

export const stateOption = [
	{
		option: "QLD",
		value: "QLD",
	},
	{
		option: "NSW",
		value: "NSW",
	},
	{
		option: "SA",
		value: "SA",
	},
	{
		option: "NT",
		value: "NT",
	},
	{
		option: "WA",
		value: "WA",
	},
	{
		option: "TAS",
		value: "TAS",
	},
	{
		option: "ACT",
		value: "ACT",
	},
	{
		option: "VIC",
		value: "VIC",
	},
];

export const loan_type = [
	{
		option: "Car Loan",
		id: 1,
		value: "Car Loan",
	},
	{
		option: "Boat Loan",
		id: 2,
		value: "Boat Loan",
	},
	{
		option: "Truck Loan",
		id: 8,
		value: "Truck Loan",
	},
	{
		option: "Equipment Loan",
		id: 6,
		value: "Equipment Loan",
	},
	{
		option: "Caravan Loan",
		id: 4,
		value: "Caravan Loan",
	},
	{
		option: "Motorcycle Loan",
		id: 3,
		value: "Motorcycle Loan",
	},
	{
		option: "Personal Loan",
		id: 5,
		value: "Personal Loan",
	},
	{
		option: "Novated Lease",
		id: 1,
		value: "Novated Lease",
	},
];

export const loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
];

export const car_loan_purpose = [
	{
		option: "Personal",
		id: 1,
		value: "Personal",
	},
	{
		option: "Business",
		id: 2,
		value: "Business",
	},
	{
		option: "Novated Lease",
		id: 1,
		value: "Novated Lease",
	},
];

export const boat_asset_type = [
	{
		option: "Boat",
		value: "Boat",
	},
	{
		option: "Jet Ski / PWC",
		value: "Jet Ski / PWC",
	},
	{
		option: "Sailboat / Yacht",
		value: "Sailboat / Yacht",
	},
	{
		option: "Houseboat",
		value: "Houseboat",
	},
	{
		option: "Commercial Boat",
		value: "Commercial Boat",
	},
];

export const equipment_asset_type = [
	{
		option: "Assets",
		value: "Assets",
	},
	{
		option: "Vehicle",
		value: "Vehicle",
	},
	{
		option: "General",
		value: "General",
	},
];

export const personal_loan_purpose = [
	{
		option: LOAN_PURPOSE_NEW,
		value: LOAN_PURPOSE_NEW,
	},
	{
		option: LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING,
		value: LOAN_PURPOSE_DEBT_CONSOLIDATION_REFINANCING,
	},
];

export const purchase_stage = [
	{
		option: "Actively Looking",
		value: "Actively Looking",
	},
	{
		option: "Found One - Ready to Finance",
		value: "Found One - Ready to Finance",
	},
	{
		option: "Refinance Existing",
		value: "Refinance Existing",
	},
];

export const living_status = [
	{
		option: "Home Owner - With Mortgage",
		id: 1,
		value: "Home Owner - With Mortgage",
	},
	{
		option: "Home Owner - No Mortgage",
		id: 2,
		value: "Home Owner - No Mortgage",
	},
	{
		option: "Renting",
		id: 3,
		value: "Renting",
	},
	{
		option: "Living with Family",
		id: 4,
		value: "Living with Family",
	},
];

export const employment_status = [
	{
		option: "Full time",
		id: 1,
		value: "Full time",
	},
	{
		option: "Part time",
		id: 2,
		value: "Part time",
	},
	{
		option: "Casual",
		id: 3,
		value: "Casual",
	},
	{
		option: "Self-employed",
		id: 4,
		value: "Self-employed",
	},
	{
		option: "Contractor",
		id: 11,
		value: "Contractor",
	},
	{
		option: "Retired",
		id: 9,
		value: "Retired",
	},
	{
		option: "Self-funded Retiree",
		id: 10,
		value: "Self-funded Retiree",
	},
	{
		option: "Government Benefits",
		id: 7,
		value: "Government Benefits",
	},
];

export const credit_history = [
	{
		option: "Good",
		value: "Good",
	},
	{
		option: "Fair",
		value: "Fair",
	},
	{
		option: "Paid Defaults",
		value: "Paid Defaults",
	},
	{
		option: "Un-Paid Defaults",
		value: "Un-Paid Defaults",
	},
	{
		option: "Ex Bankrupt",
		value: "Ex Bankrupt",
	},
	{
		option: "Unsure",
		value: "Unsure",
	},
];

export const abn_status = [
	{
		option: "New Business ABN",
		value: "New Business ABN",
	},
	{
		option: "Less than 1 Year",
		value: "Less than 1 Year",
	},
	{
		option: "More than 1 Year",
		value: "More than 1 Year",
	},
];

export const gst_status = [
	{
		option: "Not registered for GST",
		value: "Not registered for GST",
	},
	{
		option: "6 Months +",
		value: "6 Months +",
	},
	{
		option: "12 Months +",
		value: "12 Months +",
	},
];

// Business Loan
export const LOAN_PURPOSE_BUSINESS_VEHICLE = "Business Vehicle Finance";
export const LOAN_PURPOSE_TRUCK = "Truck Finance";
export const LOAN_PURPOSE_EQUIPMENT = "Equipment Finance";

export const loanFieldsMap: Record<string, Record<string, any[]>> = {
	"Car Loan": {
		loanPurpose: [...car_loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Boat Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [...boat_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Truck Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Equipment Loan": {
		loanPurpose: [loan_purpose[1]],
		purchaseStage: [...purchase_stage],
		assetType: [...equipment_asset_type],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Caravan Loan": {
		loanPurpose: [...loan_purpose],
		purchaseStage: [...purchase_stage],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [...abn_status],
		gstStatus: [...gst_status],
		creditHistory: [...credit_history],
	},
	"Personal Loan": {
		loanPurpose: [...personal_loan_purpose],
		purchaseStage: [],
		assetType: [],
		livingStatus: [...living_status],
		employmentStatus: [...employment_status],
		abnStatus: [],
		gstStatus: [],
		creditHistory: [...credit_history],
	},
};

export const stepProcessMap: Record<string, Record<string, any>> = {
	// Default Steps for all Loan Types except Mortgage and Personal Loan
	Default: [
		{
			id: 0,
			name: "Personal Details",
		},
		{
			id: 1,
			name: "Verification",
		},
		{
			id: 2,
			name: "Loan Details",
		},
		{
			id: 3,
			name: "Living Details",
		},
		{
			id: 4,
			name: "Additional Information",
		},
		{
			id: 5,
			name: "Completed",
		},
	],
};
// App theme settings
export const appSettingsConfig: Record<string, Record<string, string>> = {
	"Easy Boat Loans": {
		themeColor: "#2192ff",
		hoverColor: "#1f7fd8",
		themeHeaderTxt: "#142f48",
		bulletBG: "#DBEAFE",
	},
	"Easy Caravan Finance": {
		themeColor: "#f55c00",
		hoverColor: "#c24a00",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFD6A7",
	},
	"Easy Car Finance": {
		themeColor: "#A30000",
		hoverColor: "#810000",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FFC9C9",
	},
	"Easy Equipment Finance": {
		themeColor: "#ffad00",
		hoverColor: "#eca200",
		themeHeaderTxt: "#142f48",
		bulletBG: "#FEF9C2",
	},
	"Easy Truck Finance": {
		themeColor: "#fab000",
		hoverColor: "#dd9b00",
		themeHeaderTxt: "#142f48",
		bulletBG: "#ffe3a1",
	},
	"Easy Personal Loans": {
		themeColor: "#a6c36f",
		hoverColor: "#9eb96c",
		themeHeaderTxt: "#1e352f",
		bulletBG: "#e4ecd5",
	},
};
